"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_business__phone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "1ba2cb5b-4f1d-4120-9991-9265ef0f44e6",
    "data-name": "business-phone-hi",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 191.5 191.5"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "4a284ee3-339c-46bf-937b-62fecb495809",
    x1: 89.84,
    y1: 44.84,
    x2: 141.66,
    y2: 96.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6f6f6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "7d93ef16-4ae8-4803-8db7-98a6b88a25ea",
    x1: 24.57,
    y1: 61.95,
    x2: 146.62,
    y2: 184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "business-phone-hi"), /*#__PURE__*/React.createElement("g", {
    id: "f9c9b1aa-38d4-4308-a8f1-45bc87d748e6",
    "data-name": "Cloud_upload_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cb10b965-e811-4898-83ef-6dc0a6b901f5",
    "data-name": "Calls_Contacts_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "91201249-3dfc-4e85-89a4-d154e09f245b",
    "data-name": "PayG_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5c1a9946-7534-4b5c-8683-369a9af2740d",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9e0a0077-f2de-4891-b954-8d572531fdaf",
    "data-name": "My_Vodafone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "49cbc043-b849-44af-ab90-0d377b0d448c",
    "data-name": "Settings_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "23b3b765-03e4-4284-84c7-abd071008284",
    "data-name": "User_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6b5b3663-9fbe-40a5-b143-cd7ba91f9336",
    "data-name": "Video_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8d41cc3a-7b37-4feb-88fa-1d72d523c326",
    "data-name": "Tutorials_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6f50e919-7868-4f38-af69-35aa0efa1a56",
    "data-name": "Community_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a8ead0e5-c610-4fad-b331-225d6e4dca8a",
    "data-name": "Entertainment_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2f0dccb0-3e72-4a80-b805-b5eaf4b70894",
    "data-name": "Insurance_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2c45319c-2029-441f-a584-03859ef749c8",
    "data-name": "Photos_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "006c3f32-96dd-4995-b75b-bfe7c8c3526a",
    "data-name": "Pie_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9f75c664-5e94-4f64-a804-d81c79e2780a",
    "data-name": "Shopping_trolley_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b5b4599f-d460-4c54-a776-3d6037f935a9",
    "data-name": "Business_phone_ic_hi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.25,27.75h104.5a16,16,0,0,1,16,16v104a16,16,0,0,1-16,16H55.25a0,0,0,0,1,0,0v-136A0,0,0,0,1,55.25,27.75Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.76,
    y: 99.76,
    width: 70.99,
    height: 3.99,
    rx: 1.99,
    ry: 1.99,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.76,
    y: 111.76,
    width: 70.99,
    height: 3.99,
    rx: 1.99,
    ry: 1.99,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.76,
    y: 123.76,
    width: 70.99,
    height: 3.99,
    rx: 1.99,
    ry: 1.99,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "8f3d1c3a-798e-4e6c-9675-be6b59e07a36",
    "data-name": "Bounding Box",
    x: 0.25,
    y: 0.25,
    width: 191.5,
    height: 191.5,
    transform: "translate(191.75 -0.25) rotate(90)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.75,
    y: 49.75,
    width: 72,
    height: 42,
    rx: 4,
    ry: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.75,
    y: 51.75,
    width: 68,
    height: 38,
    rx: 2,
    ry: 2,
    fill: "#333",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.75,
    y: 51.75,
    width: 68,
    height: 38,
    rx: 2,
    ry: 2,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.75,
    y: 51.75,
    width: 68,
    height: 38,
    rx: 2,
    ry: 2,
    opacity: 0.5,
    fill: "url(#4a284ee3-339c-46bf-937b-62fecb495809)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,164H58.74L58.51,28,176,145.5l0,3.53C176,157.25,167.75,164,161,164Z",
    transform: "translate(-0.25 -0.25)",
    opacity: 0.2,
    fill: "url(#7d93ef16-4ae8-4803-8db7-98a6b88a25ea)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145.75,
    cy: 144.17,
    r: 6,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.75,
    y: 23.75,
    width: 48,
    height: 144,
    rx: 16,
    ry: 16,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,162H60.48A15.92,15.92,0,0,0,64,152v-2a16,16,0,0,1-16,16H32a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16H48a15.92,15.92,0,0,0,10.56-4H160a16,16,0,0,0,16-16v-2A16,16,0,0,1,160,162Z",
    transform: "translate(-0.25 -0.25)",
    opacity: 0.06
  }))))))))))))))))));
}

var _default = ic_business__phone;
exports.default = _default;